export const ru: Record<string, string> = {
    'dashboard.nav.overview': 'Обзор',
    'dashboard.nav.users': 'Пользователи',
    'dashboard.nav.prompts': 'Промпты',
    'dashboard.nav.testConfigs': 'Конфигурации тестов',
    'dashboard.nav.sensecap': 'SenseCAP',
    'dashboard.nav.deviceSensors': 'Датчики устройств',
    'dashboard.nav.postureInstructions': 'Инструкции по позе',
    'dashboard.nav.mediaFiles': 'Библиотека файлов',
    'dashboard.nav.testMetrics': 'Метрики тестов',
    'dashboard.nav.disclaimers': 'Дисклеймеры',
    'dashboard.nav.legalDocuments': 'Юридические документы',
    'dashboard.nav.testCategories': 'Категории тестов',
    'dashboard.nav.entitlements': 'Entitlements',
    'dashboard.nav.questionnaires': 'Опросники',
    'dashboard.nav.testScripts': 'Python-скрипты',
    'dashboard.collapseSidebar': 'Свернуть меню',
    'dashboard.expandSidebar': 'Развернуть меню',
    'dashboard.logout': 'Выйти',

    'login.title': 'Вход в систему',
    'login.password': 'Пароль',
    'login.submit': 'Войти',

    'common.cancel': 'Отмена',
    'common.save': 'Сохранить',
    'common.close': 'Закрыть',
    'common.add': 'Добавить',
    'common.delete': 'Удалить',
    'common.edit': 'Редактировать',
    'common.copy': 'Копировать',
    'common.done': 'Готово',
    'common.loading': 'Загрузка...',
    'common.noData': 'Нет данных',
    'common.error': 'Ошибка',

    'keyValue.key': 'Ключ',
    'keyValue.value': 'Значение',
    'keyValue.actions': 'Действия',
    'keyValue.editTitle': 'Редактирование: {key}',
    'keyValue.addTitle': 'Добавление',
    'keyValue.newKey': 'Новый ключ',
    'keyValue.applyAll': 'Применить ко всем пользователям',
    'keyValue.userProps': 'Свойства пользователя',
    'keyValue.userFiles': 'Файлы пользователя',
    'keyValue.userPrompts': 'Промпты пользователя',
    'keyValue.description': 'Описание',
    'keyValue.image': 'Изображение',
    'keyValue.replaceImage': 'Заменить изображение',
    'keyValue.chooseImage': 'Выбрать изображение',
    'keyValue.preview': 'Предпросмотр',
    'keyValue.removeImage': 'Удалить изображение',
    'keyValue.generatedRecs': 'Сгенерированные рекомендации:',
    'keyValue.confirmDelete': 'Вы уверены, что хотите удалить запись!',
    'keyValue.confirmApplyAll':
        'Вы уверены, что хотите применить свойства этого пользователя ко ВСЕМ пользователям? \n    Все существующие свойства других пользователей будут удалены!',
    'keyValue.applySuccess': 'Свойства успешно применены ко всем пользователям!',
    'keyValue.errorPrefix': 'Ошибка: {message}',
    'keyValue.keyEmpty': 'Ключ не может быть пустым',
    'keyValue.addFailed': 'Не удалось добавить свойство',
    'keyValue.duplicateKey': 'Свойство с ключом "{key}" уже существует',

    'reports.deleteRow': 'Удалить',
    'reports.deleteEcgConfirm': 'Удалить эту ЭКГ?',
    'reports.testConfig': 'Конфиг',

    'users.manageProps': 'Управление свойствами пользователя',
    'users.generateRec': 'Генерация рекомендации',
    'users.generating': 'Генерация...',
    'users.genFailed': 'Не удалось сгенерировать рекомендации',
    'users.manager': 'Руководитель',
    'users.assignManager': 'Назначить руководителя',
    'users.clearManager': 'Без руководителя',
    'users.managerSaved': 'Руководитель обновлён',
    'users.managerSaveFailed': 'Не удалось обновить руководителя',

    'reportDetail.deleteReportConfirm': 'Удалить этот отчёт?',
    'reportDetail.deleteFailed': 'Не удалось удалить отчёт',
    'reportDetail.xlsFailed': 'Не удалось скачать XLS',
    'reportDetail.errorStatus': 'Ошибка {status}',
    'reportDetail.pdfFailed': 'Не удалось скачать PDF',
    'reportDetail.shortPdfFailed': 'Не удалось скачать краткий PDF',
    'reportDetail.selectPrompt': 'Выберите промпт',
    'reportDetail.genError': 'Ошибка генерации',
    'reportDetail.genFailed': 'Не удалось сгенерировать рекомендации',
    'reportDetail.notFound': 'Отчёт не найден.',
    'reportDetail.backToUser': 'Назад к пользователю',
    'reportDetail.reportN': 'Отчёт #{id}',
    'reportDetail.date': 'Дата:',
    'reportDetail.comment': 'Комментарий:',
    'reportDetail.user': 'Пользователь:',
    'reportDetail.properties': 'Свойства',
    'reportDetail.propertiesTime': 'Время',
    'reportDetail.propertiesName': 'Название',
    'reportDetail.propertiesValue': 'Значение',
    'reportDetail.testConfig': 'Конфиг:',
    'reportDetail.testConfigCategory': 'Категория:',
    'reportDetail.ecgFilter': 'Формирование экг с фильтром',
    'reportDetail.shortPdf': 'Краткий PDF',
    'reportDetail.aiGen': 'Генерация ИИ',
    'reportDetail.optionalQuestion': 'Уточняющий вопрос (необязательно)',
    'reportDetail.clarifyingQuestionLabel': 'Уточняющий вопрос',
    'reportDetail.generating': 'Генерация…',
    'reportDetail.generate': 'Сгенерировать',
    'reportDetail.result': 'Результат',
    'reportDetail.inputSent': 'Вход (что отправлено)',
    'reportDetail.answer': 'Ответ',
    'reportDetail.history': 'История генераций',
    'reportDetail.noHistory': 'Нет записей',
    'reportDetail.inputHistory': 'Вход:',
    'reportDetail.answerHistory': 'Ответ:',

    'prompts.status.draft': 'Черновик',
    'prompts.status.active': 'Опубликован',
    'prompts.status.archived': 'В архиве',
    'prompts.deleteConfirm': 'Удалить этот промпт?',
    'prompts.deleteFailed': 'Не удалось удалить',
    'prompts.title': 'Все промпты',
    'prompts.allUsers': 'Все пользователи',
    'prompts.allReportTypes': 'Все типы отчётов',
    'prompts.add': 'Добавить промпт',
    'prompts.colUser': 'Пользователь',
    'prompts.colReportType': 'Тип отчёта',
    'prompts.colName': 'Название',
    'prompts.colStatus': 'Статус',
    'prompts.colUpdated': 'Последнее изменение',
    'prompts.colActions': 'Действия',
    'prompts.empty': 'Нет промптов',
    'prompts.editHint': 'Редактировать',
    'prompts.historyHint': 'История изменений',
    'prompts.deleteHint': 'Удалить',
    'prompts.enterName': 'Введите название',
    'prompts.enterText': 'Введите текст промпта',
    'prompts.saveFailed': 'Не удалось сохранить',
    'prompts.newTitle': 'Новый промпт',
    'prompts.forAllUsers': 'Для всех пользователей',
    'prompts.globalAlreadyExists':
        'Для этого типа отчёта уже есть промпт для всех пользователей. Отредактируйте существующий.',
    'prompts.user': 'Пользователь',
    'prompts.name': 'Название',
    'prompts.reportType': 'Тип отчёта',
    'prompts.publishNow': 'Опубликовать сейчас',
    'prompts.saveAsDraft': 'Сохранить как черновик',
    'prompts.promptText': 'Текст промпта',
    'prompts.note': 'Заметка',
    'prompts.saveDraftBtn': 'Сохранить черновик',
    'prompts.publish': 'Опубликовать',
    'prompts.editTitlePrefix': 'Редактирование:',
    'prompts.reportTypeStatic': 'Тип отчёта:',
    'prompts.publishRadio': 'Опубликовать',
    'prompts.draftRadio': 'Черновик',
    'prompts.versionTitle': 'История изменений промпта',
    'prompts.savedRevisions': 'Сохранённые редакции',
    'prompts.when': 'Когда',
    'prompts.version': 'Версия',
    'prompts.content': 'Содержание',
    'prompts.activeCol': 'Активна',
    'prompts.actionsCol': 'Действия',
    'prompts.makeActive': 'Сделать активной',
    'prompts.testCopies': 'Копии для тестирования',
    'prompts.noCopies': 'Нет копий',
    'prompts.createCopy': '+ Создать копию для тестирования',
    'prompts.creating': 'Создание...',
    'prompts.branchFailed': 'Не удалось создать копию',
    'prompts.allStatuses': 'Все статусы',
    'prompts.migrateGlobalDuplicates': 'Мигрировать массовые промпты',
    'prompts.migrateGlobalDuplicatesConfirm':
        'Создать глобальные шаблоны из старых массовых копий? Персональные копии удалены не будут.',
    'prompts.migrateGlobalDuplicatesSuccess':
        'Миграция завершена. Создано: {globalCreated}, групп найдено: {groupsFound}, пропущено: {skipped}.',
    'prompts.migrateGlobalDuplicatesFailed': 'Не удалось выполнить миграцию промптов',
    'userPrompts.selectReportBelow': 'Выберите отчёт в таблице ниже',
    'userPrompts.getAiRecommendations': 'Получить рекомендации ИИ',
    'userPrompts.selectReportHint':
        'Выберите отчёт в таблице ниже и нажмите иконку «Получить рекомендации ИИ» у нужного промпта.',
    'userPrompts.howSave': 'Как сохранить:',
    'userPrompts.noteForSelf': 'Заметка (для себя)',

    'documents.loadFailed': 'Не удалось загрузить документы',
    'documents.pdfOnly': 'Разрешены только PDF файлы',
    'documents.sizeLimit': 'Размер файла не должен превышать 10MB',
    'documents.pickFile': 'Выберите файл для загрузки',
    'documents.uploaded': 'Документ успешно загружен',
    'documents.uploadFailed': 'Не удалось загрузить документ',
    'documents.deleteConfirm': 'Вы уверены, что хотите удалить этот документ?',
    'documents.deleted': 'Документ удалён',
    'documents.deleteFailed': 'Не удалось удалить документ',
    'documents.downloading': 'Документ скачивается',
    'documents.downloadFailed': 'Не удалось скачать документ',
    'documents.previewFailed': 'Не удалось открыть документ',
    'documents.name': 'Название',
    'documents.size': 'Размер',
    'documents.uploadedAt': 'Дата загрузки',
    'documents.actions': 'Действия',
    'documents.download': 'Скачать',
    'documents.empty': 'Нет загруженных документов',
    'documents.uploadTitle': 'Загрузить документ',
    'documents.chooseFile': 'Выбрать файл',
    'documents.fileLabel': 'Файл:',
    'documents.sizeLabel': 'Размер:',
    'documents.pdfHint': 'Только PDF файлы до 10MB',
    'documents.uploading': 'Загрузка...',
    'documents.upload': 'Загрузить',
    'documents.previewTitle': 'Просмотр:',
    'documents.uploadButton': 'Загрузить документ',
    'documents.stats': 'Всего документов: {count} • Общий размер: {size}',

    'testConfigs.error': 'Ошибка',
    'testConfigs.uncategorized': 'Без категории',
    'testConfigs.deleteConfirm': 'Удалить конфигурацию "{name}"?',
    'testConfigs.scriptLoadFailed': 'Не удалось загрузить скрипт',
    'testConfigs.deleteScriptConfirm': 'Удалить скрипт?',
    'testConfigs.title': 'Конфигурации тестов',
    'testConfigs.new': 'Новая конфигурация',
    'testConfigs.newCategory': 'Новая категория',
    'testConfigs.refresh': 'Обновить',
    'testConfigs.noConfigs': 'Нет конфигураций',
    'testConfigs.createFirst': 'Создать первую',
    'testConfigs.selectConfig': 'Выберите конфигурацию',
    'testConfigs.edit': 'Редактировать',
    'testConfigs.copy': 'Копировать',
    'testConfigs.newCategoryDialog': 'Новая категория',
    'testConfigs.categoryName': 'Название категории',
    'testConfigs.create': 'Создать',
    'testConfigs.script': 'Скрипт',
    'testConfigs.pdfScript': 'Скрипт генерации PDF',
    'testConfigs.indicatorsScript': 'Скрипт индикаторов',
    'testConfigs.noScript': 'Не выбран',
    'testConfigs.scriptPresent': 'Есть',
    'testConfigs.replace': 'Заменить',
    'testConfigs.remove': 'Удалить',
    'testConfigs.uploadPy': 'Загрузить .py',
    'testConfigs.enabled': 'Включено',
    'testConfigs.copySuffix': ' (копия)',
    'testConfigs.enterName': 'Введите название',
    'testConfigs.pickOutputMetric': 'Выберите хотя бы одну метрику в Output metrics',
    'testConfigs.saveFailed': 'Не удалось сохранить',
    'testConfigs.dialogEdit': 'Редактировать конфигурацию',
    'testConfigs.dialogCopy': 'Копировать конфигурацию',
    'testConfigs.dialogNew': 'Новая конфигурация',
    'testConfigs.fieldName': 'Название',
    'testConfigs.fieldType': 'Тип',
    'testConfigs.fieldDescription': 'Описание',
    'testConfigs.fieldGoal': 'Цель',
    'testConfigs.fieldSensors': 'Датчики',
    'testConfigs.fieldPosture': 'Поза',
    'testConfigs.fieldOutput': 'Данные на выходе',
    'testConfigs.fieldWhy': 'Почему важно',
    'testConfigs.fieldHow': 'Как работает',
    'testConfigs.durationSec': 'Длительность (сек)',
    'testConfigs.stages': 'Этапы',
    'testConfigs.outputMetrics': 'Output metrics',
    'testConfigs.resultMetrics': 'Result metrics',
    'testConfigs.fieldCategory': 'Категория',
    'testConfigs.fieldIndex': 'Индекс',
    'testConfigs.iconColor': 'Цвет иконки',
    'testConfigs.icon': 'Иконка',
    'testConfigs.chipActive': 'Активна',
    'testConfigs.chipDisabled': 'Отключена',
    'testConfigs.durationChip': 'Длительность: {n} сек',
    'testConfigs.stagesChip': 'Этапы: {n}',
    'testConfigs.categoryId': 'Категория',
    'testConfigs.sensorIds': 'Датчики',
    'testConfigs.postureInstructionIds': 'Инструкции по позе',
    'testConfigs.fieldStatus': 'Статус',
    'testConfigs.status.active': 'Активен',
    'testConfigs.status.inactive': 'Неактивен',
    'testConfigs.status.hidden': 'Скрыт',
    'testConfigs.status.dep': 'Устарел',
    'testConfigs.entitlementIds': 'Entitlements',
    'testConfigs.disclaimerIds': 'Дисклеймеры',
    'testConfigs.entitlementIdsHint': 'Пусто = без ограничений',
    'testConfigs.migrateEntitlements': 'Мигрировать entitlements',
    'testConfigs.migrateEntitlementsHint':
        'У части конфигураций или категорий остались legacy-строки entitlements. Запустите миграцию для привязки к справочнику.',
    'testConfigs.migrateEntitlementsSuccess':
        'Миграция entitlements: создано {created}, привязано конфигов {linkedConfigs}, категорий {linkedCategories}',
    'testConfigs.metadata': 'Metadata (JSON)',
    'testConfigs.pickCategory': 'Выберите категорию',
    'testConfigs.invalidMetadata': 'Некорректный JSON metadata',
    'testConfigs.migrateCategories': 'Мигрировать категории',
    'testConfigs.migrateCategoriesHint': 'У части конфигураций есть legacy categoryName без связи со справочником. Запустите миграцию для привязки к TestCategory.',
    'testConfigs.migrateSuccess': 'Миграция: обновлено {updated}, создано категорий {created}',
    'testConfigs.fieldMediaFile': 'Иконка (библиотека файлов)',
    'testConfigs.fieldInstructionMedia': 'Инструкция (аудио/видео)',
    'testConfigs.migrateIcons': 'Мигрировать иконки',
    'testConfigs.migrateIconsHint':
        'У части конфигураций или категорий остались legacy-ключи статических иконок. Запустите миграцию для импорта в библиотеку файлов и привязки записей.',
    'testConfigs.migrateIconsSuccess':
        'Миграция иконок: импортировано {imported}, привязано конфигов {linkedConfigs}, категорий {linkedCategories}',
    'testConfigs.migrateIconsUnmatched': 'Не удалось сопоставить {count} записей с файлом',
    'testConfigs.migrateMediaFiles': 'Мигрировать файлы',
    'testConfigs.migrateMediaFilesHint':
        'Часть записей всё ещё ссылается на устаревшую SVG-библиотеку. Запустите миграцию, чтобы скопировать файлы в библиотеку файлов и привязать записи.',
    'testConfigs.migrateMediaFilesSuccess':
        'Миграция файлов: перенесено {migrated}, привязано поз {linkedPostures}, конфигов {linkedConfigs}, категорий {linkedCategories}',
    'testConfigs.categoryUnlinked': 'Категория «{name}» не привязана к справочнику',
    'testConfigs.manageCategories': 'Управление категориями',

    'testCategories.title': 'Категории тестов',
    'testCategories.new': 'Новая категория',
    'testCategories.refresh': 'Обновить',
    'testCategories.empty': 'Нет категорий',
    'testCategories.deleteConfirm': 'Удалить категорию «{type}»?',
    'testCategories.deleteFailed': 'Не удалось удалить категорию',
    'testCategories.saveFailed': 'Не удалось сохранить категорию',
    'testCategories.enterType': 'Введите тип категории',
    'testCategories.enterName': 'Введите название',
    'testCategories.enterDescription': 'Введите описание',
    'testCategories.invalidHex': 'Некорректный hex-цвет (#RRGGBB)',
    'testCategories.dialogNew': 'Новая категория',
    'testCategories.dialogEdit': 'Редактировать категорию',
    'testCategories.colType': 'Тип',
    'testCategories.colName': 'Название',
    'testCategories.colItemsName': 'Items name',
    'testCategories.colSortOrder': 'Порядок',
    'testCategories.colStatus': 'Статус',
    'testCategories.colActions': 'Действия',
    'testCategories.fieldType': 'Тип',
    'testCategories.fieldName': 'Название',
    'testCategories.fieldDescription': 'Описание',
    'testCategories.fieldItemsName': 'Items name',
    'testCategories.fieldIcon': 'Иконка',
    'testCategories.fieldMediaFile': 'Иконка (библиотека файлов)',
    'testCategories.colIcon': 'Иконка',
    'testCategories.fieldIconColor': 'Цвет иконки',
    'testCategories.fieldSortOrder': 'Порядок сортировки',
    'testCategories.fieldStatus': 'Статус',
    'testCategories.fieldEntitlements': 'Entitlements',
    'testCategories.entitlementIds': 'Entitlements',
    'testCategories.entitlementIdsHint': 'Пусто = без ограничений',
    'testCategories.status.active': 'Активна',
    'testCategories.status.inactive': 'Неактивна',
    'testCategories.status.archived': 'В архиве',

    'deviceSensors.title': 'Датчики устройств',
    'deviceSensors.new': 'Новый датчик',
    'deviceSensors.refresh': 'Обновить',
    'deviceSensors.empty': 'Нет датчиков',
    'deviceSensors.deleteConfirm': 'Удалить датчик "{type}"?',
    'deviceSensors.deleteFailed': 'Не удалось удалить датчик',
    'deviceSensors.saveFailed': 'Не удалось сохранить датчик',
    'deviceSensors.enterType': 'Введите тип датчика',
    'deviceSensors.enterDescription': 'Введите описание',
    'deviceSensors.dialogNew': 'Новый датчик устройства',
    'deviceSensors.dialogEdit': 'Редактировать датчик',
    'deviceSensors.colType': 'Тип',
    'deviceSensors.colDescription': 'Описание',
    'deviceSensors.colStatus': 'Статус',
    'deviceSensors.colActions': 'Действия',
    'deviceSensors.fieldType': 'Тип',
    'deviceSensors.fieldDescription': 'Описание',
    'deviceSensors.fieldStatus': 'Статус',
    'deviceSensors.status.active': 'Активен',
    'deviceSensors.status.inactive': 'Неактивен',
    'entitlements.title': 'Entitlements',
    'entitlements.new': 'Новый entitlement',
    'entitlements.refresh': 'Обновить',
    'entitlements.empty': 'Нет записей',
    'entitlements.deleteConfirm': 'Удалить entitlement «{type}»?',
    'entitlements.deleteFailed': 'Не удалось удалить',
    'entitlements.saveFailed': 'Не удалось сохранить',
    'entitlements.enterType': 'Введите type',
    'entitlements.dialogNew': 'Новый entitlement',
    'entitlements.dialogEdit': 'Редактировать entitlement',
    'entitlements.colType': 'Type',
    'entitlements.colDescription': 'Описание',
    'entitlements.colStatus': 'Статус',
    'entitlements.colActions': 'Действия',
    'entitlements.fieldType': 'Type',
    'entitlements.fieldDescription': 'Описание',
    'entitlements.status.active': 'Активен',
    'entitlements.status.inactive': 'Неактивен',
    'entitlements.status.archived': 'Архив',

    'questionnaires.title': 'Опросники',
    'questionnaires.new': 'Новая анкета',
    'questionnaires.refresh': 'Обновить',
    'questionnaires.empty': 'Нет анкет',
    'questionnaires.emptyQuestions': 'Нет вопросов',
    'questionnaires.emptyOptions': 'Нет вариантов',
    'questionnaires.questionnaires': 'Анкеты',
    'questionnaires.questions': 'Вопросы',
    'questionnaires.options': 'Варианты',
    'questionnaires.newQuestion': 'Новый вопрос',
    'questionnaires.newOption': 'Новый вариант',
    'questionnaires.selectQuestionnaire': 'Выберите анкету',
    'questionnaires.selectQuestion': 'Выберите вопрос',
    'questionnaires.deactivateConfirm': 'Деактивировать «{title}»?',
    'questionnaires.saveFailed': 'Не удалось сохранить',
    'questionnaires.requiredFields': 'Заполните код и название',
    'questionnaires.dialogNew': 'Новая анкета',
    'questionnaires.dialogEdit': 'Редактировать анкету',
    'questionnaires.dialogNewQuestion': 'Новый вопрос',
    'questionnaires.dialogEditQuestion': 'Редактировать вопрос',
    'questionnaires.dialogNewOption': 'Новый вариант',
    'questionnaires.dialogEditOption': 'Редактировать вариант',
    'questionnaires.colCode': 'Код',
    'questionnaires.colTitle': 'Название',
    'questionnaires.colDescription': 'Описание',
    'questionnaires.colOrder': 'Порядок',
    'questionnaires.colStatus': 'Статус',
    'questionnaires.colType': 'Тип',
    'questionnaires.colLabel': 'Подпись',
    'questionnaires.colActions': 'Действия',
    'questionnaires.minSelections': 'Минимум вариантов',
    'questionnaires.maxSelections': 'Максимум вариантов',
    'questionnaires.required': 'Обязательный',
    'questionnaires.status.active': 'Активен',
    'questionnaires.status.inactive': 'Неактивен',
    'questionnaires.answers': 'Ответы',
    'questionnaires.emptyAnswers': 'Нет ответов',
    'questionnaires.colUser': 'Пользователь',
    'questionnaires.colCompleted': 'Завершено',
    'questionnaires.colAnswers': 'Ответы',
    'questionnaires.completedYes': 'Да',
    'questionnaires.completedNo': 'Нет',
    'questionnaires.yes': 'Да',
    'questionnaires.no': 'Нет',

    'postureInstructions.title': 'Инструкции по позе',
    'postureInstructions.new': 'Новая инструкция',
    'postureInstructions.refresh': 'Обновить',
    'postureInstructions.empty': 'Нет инструкций',
    'postureInstructions.deleteConfirm': 'Удалить инструкцию «{title}»?',
    'postureInstructions.deleteFailed': 'Не удалось удалить инструкцию',
    'postureInstructions.saveFailed': 'Не удалось сохранить инструкцию',
    'postureInstructions.enterType': 'Введите тип позы',
    'postureInstructions.enterTitle': 'Введите заголовок',
    'postureInstructions.enterDescription': 'Введите описание',
    'postureInstructions.enterOrder': 'Введите корректный порядок (целое число >= 0)',
    'postureInstructions.dialogNew': 'Новая инструкция по позе',
    'postureInstructions.dialogEdit': 'Редактировать инструкцию',
    'postureInstructions.colType': 'Тип',
    'postureInstructions.colTitle': 'Заголовок',
    'postureInstructions.colOrder': 'Порядок',
    'postureInstructions.colStatus': 'Статус',
    'postureInstructions.colImage': 'Иллюстрация',
    'postureInstructions.colActions': 'Действия',
    'postureInstructions.fieldType': 'Тип',
    'postureInstructions.fieldTitle': 'Заголовок',
    'postureInstructions.fieldDescription': 'Описание',
    'postureInstructions.fieldOrder': 'Порядок',
    'postureInstructions.fieldStatus': 'Статус',
    'postureInstructions.status.active': 'Активна',
    'postureInstructions.status.inactive': 'Неактивна',
    'postureInstructions.status.archived': 'В архиве',
    'postureInstructions.imageSection': 'Иллюстрация',
    'postureInstructions.imageAbsent': 'Нет',
    'postureInstructions.selectImage': 'Выбрать из библиотеки',
    'postureInstructions.selectImagePlaceholder': 'Выберите изображение',
    'postureInstructions.clearImage': 'Сбросить выбор',
    'postureInstructions.openLibrary': 'Открыть библиотеку файлов',

    'mediaFiles.title': 'Библиотека файлов',
    'mediaFiles.upload': 'Загрузить файл',
    'mediaFiles.refresh': 'Обновить',
    'mediaFiles.empty': 'Нет файлов',
    'mediaFiles.deleteConfirm': 'Удалить файл «{name}»? Ссылки в связанных записях будут сброшены.',
    'mediaFiles.deleteFailed': 'Не удалось удалить файл',
    'mediaFiles.saveFailed': 'Не удалось сохранить файл',
    'mediaFiles.uploadFailed': 'Не удалось загрузить файл',
    'mediaFiles.enterName': 'Введите название',
    'mediaFiles.pickFile': 'Выберите файл',
    'mediaFiles.invalidFormat':
        'Допустимо: изображения SVG/PNG/JPEG/WebP/GIF (макс. 5 МБ); аудио MP3/WAV/OGG/M4A (макс. 20 МБ); видео MP4/WebM/MOV (макс. 80 МБ)',
    'mediaFiles.formatsHint':
        'Изображения: SVG, PNG, JPEG, WebP, GIF (макс. 5 МБ). Аудио: MP3, WAV, OGG, M4A (макс. 20 МБ). Видео: MP4, WebM, MOV (макс. 80 МБ).',
    'mediaFiles.selectAv': 'Выбрать аудио или видео',
    'mediaFiles.selectAvPlaceholder': 'Выберите аудио или видео',
    'mediaFiles.kind.image': 'Изображение',
    'mediaFiles.kind.audio': 'Аудио',
    'mediaFiles.kind.video': 'Видео',
    'mediaFiles.kind.unknown': 'Файл',
    'mediaFiles.uploadDialog': 'Загрузка файла',
    'mediaFiles.editDialog': 'Переименовать файл',
    'mediaFiles.colPreview': 'Превью',
    'mediaFiles.colName': 'Название',
    'mediaFiles.colType': 'Тип',
    'mediaFiles.colFilename': 'Файл',
    'mediaFiles.colMime': 'MIME-тип',
    'mediaFiles.colCreated': 'Создано',
    'mediaFiles.colActions': 'Действия',
    'mediaFiles.fieldName': 'Название',

    'testScripts.title': 'Python-скрипты',
    'testScripts.upload': 'Загрузить скрипт',
    'testScripts.refresh': 'Обновить',
    'testScripts.empty': 'Нет скриптов',
    'testScripts.sectionPdf': 'Генерация PDF',
    'testScripts.sectionIndicators': 'Индикаторы',
    'testScripts.deleteConfirm': 'Удалить скрипт «{name}»?',
    'testScripts.deleteFailed': 'Не удалось удалить скрипт. Возможно, он используется в конфигурациях.',
    'testScripts.saveFailed': 'Не удалось сохранить скрипт',
    'testScripts.uploadFailed': 'Не удалось загрузить скрипт',
    'testScripts.download': 'Скачать файл',
    'testScripts.downloadFailed': 'Не удалось скачать файл скрипта',
    'testScripts.replaceFile': 'Заменить файл',
    'testScripts.replaceDialog': 'Замена файла Python-скрипта',
    'testScripts.currentFile': 'Текущий файл',
    'testScripts.chooseReplacement': 'Выберите новый .py файл',
    'testScripts.replaceFailed': 'Не удалось заменить файл скрипта',
    'testScripts.replaceSuccess': 'Файл скрипта успешно заменён',
    'testScripts.enterName': 'Введите название',
    'testScripts.pickFile': 'Выберите .py файл',
    'testScripts.invalidFormat': 'Допустимы только .py файлы до 2 МБ',
    'testScripts.uploadDialog': 'Загрузка Python-скрипта',
    'testScripts.editDialog': 'Переименовать скрипт',
    'testScripts.colName': 'Название',
    'testScripts.colPurpose': 'Раздел',
    'testScripts.colFilename': 'Файл',
    'testScripts.colCreated': 'Создано',
    'testScripts.colActions': 'Действия',
    'testScripts.fieldName': 'Название',
    'testScripts.fieldPurpose': 'Раздел',

    'testMetrics.title': 'Метрики тестов',
    'testMetrics.new': 'Новая метрика',
    'testMetrics.refresh': 'Обновить',
    'testMetrics.empty': 'Нет метрик',
    'testMetrics.deleteConfirm': 'Удалить метрику «{type}»?',
    'testMetrics.deleteFailed': 'Не удалось удалить метрику',
    'testMetrics.saveFailed': 'Не удалось сохранить метрику',
    'testMetrics.enterType': 'Введите тип метрики',
    'testMetrics.enterTitle': 'Введите заголовок',
    'testMetrics.enterValidationKey': 'Введите validation key',
    'testMetrics.invalidHex': 'Некорректный hex-цвет (#RRGGBB)',
    'testMetrics.scaleMinMax': 'Шкала «{name}»: min должен быть меньше max',
    'testMetrics.levelMinMax': 'Уровень «{label}»: min должен быть <= max',
    'testMetrics.dialogNew': 'Новая метрика',
    'testMetrics.dialogEdit': 'Редактировать метрику',
    'testMetrics.colType': 'Тип',
    'testMetrics.colTitle': 'Заголовок',
    'testMetrics.colValueType': 'Тип значения',
    'testMetrics.colEnabled': 'Включена',
    'testMetrics.colScales': 'Шкалы',
    'testMetrics.colDisclaimers': 'Дисклеймеры',
    'testMetrics.colActions': 'Действия',
    'testMetrics.enabled': 'Да',
    'testMetrics.disabled': 'Нет',
    'testMetrics.sectionMain': 'Метрика',
    'testMetrics.sectionScales': 'Шкалы',
    'testMetrics.sectionLevels': 'Уровни',
    'testMetrics.fieldType': 'Тип',
    'testMetrics.fieldTitle': 'Заголовок',
    'testMetrics.fieldShortTitle': 'Краткий заголовок',
    'testMetrics.fieldDescription': 'Описание',
    'testMetrics.fieldBenefits': 'Польза',
    'testMetrics.fieldUnit': 'Единица',
    'testMetrics.fieldValueType': 'Тип значения',
    'testMetrics.fieldIcon': 'Иконка',
    'testMetrics.fieldIconColor': 'Цвет иконки',
    'testMetrics.fieldValidationKey': 'Validation key',
    'testMetrics.fieldTrendStrategy': 'Стратегия тренда',
    'testMetrics.fieldFormatterKey': 'Ключ форматтера',
    'testMetrics.fieldDecimals': 'Знаков после запятой',
    'testMetrics.fieldNullDisplay': 'Отображение null',
    'testMetrics.fieldTags': 'Теги (через запятую)',
    'testMetrics.disclaimerIds': 'Дисклеймеры',
    'testMetrics.fieldEnabled': 'Включена',
    'testMetrics.fieldWorkout': 'Метрика тренировки',
    'testMetrics.fieldInvertedProgress': 'Инвертированный прогресс',
    'testMetrics.fieldClamp': 'Обрезать по шкале',
    'testMetrics.addScale': 'Добавить шкалу',
    'testMetrics.removeScale': 'Удалить шкалу',
    'testMetrics.scaleUntitled': 'Шкала {n}',
    'testMetrics.levelsCount': 'уровней',
    'testMetrics.scaleName': 'Название шкалы',
    'testMetrics.scaleDescription': 'Описание шкалы',
    'testMetrics.scaleUnit': 'Единица',
    'testMetrics.scaleMin': 'Min',
    'testMetrics.scaleMax': 'Max',
    'testMetrics.scaleIndex': 'Индекс',
    'testMetrics.scaleInverted': 'Инвертирована',
    'testMetrics.addLevel': 'Добавить уровень',
    'testMetrics.levelLabel': 'Метка',
    'testMetrics.levelPriority': 'Приоритет',
    'testMetrics.levelColor': 'Цвет',

    'sensecap.title': 'SenseCAP — ритмограмма / HRV',
    'sensecap.devices': 'Устройства (devEui)',
    'sensecap.selectDevice': 'Выберите устройство слева',
    'sensecap.chartFor': 'Устройство: {devEui}',
    'sensecap.limit': 'Uplink-ов (limit)',
    'sensecap.from': 'С',
    'sensecap.to': 'По',
    'sensecap.noDevices': 'Нет данных с устройств',
    'sensecap.loadDevicesError': 'Не удалось загрузить список устройств',
    'sensecap.loadSamplesError': 'Не удалось загрузить samples',
    'sensecap.deviceMeta': 'Пакетов: {count}, последний: {lastSeen}, RSSI: {rssi}',
    'sensecap.samplesMeta': 'Uplink-ов: {uplinks}, сессий: {sessions}, точек: {points}',
    'sensecap.sessionMeta': 'Сессия: {uplinks} uplink(ов), {start} — {end}, точек: {points}',
    'sensecap.sessionPage': 'Сессия {current} из {total}',
    'sensecap.prevSession': 'Предыдущая сессия',
    'sensecap.nextSession': 'Следующая сессия',
    'sensecap.rhythmogram': 'Ритмограмма RR',
    'sensecap.histogram': 'Гистограмма RR-интервалов',
    'sensecap.scatterogram': 'Скаттерограмма RR-интервалов',
    'sensecap.amplitude': 'Амплитуда зубца R',
    'sensecap.hrvEmpty': 'Недостаточно RR-интервалов для HRV (нужно минимум 2 после фильтра).',
    'sensecap.hr': 'HR',
    'sensecap.sdnn': 'SDNN',
    'sensecap.rmssd': 'RMSSD',
    'sensecap.pnn20': 'pNN20',
    'sensecap.pnn50': 'pNN50',
    'sensecap.unitBpm': 'уд/мин',
    'sensecap.unitMs': 'мс',
    'sensecap.unitPct': '%',
    'sensecap.normalRange': 'норма: {min}–{max}',
    'sensecap.axisTimeMs': 'Время (мс)',
    'sensecap.axisRrMs': 'RR (мс)',
    'sensecap.axisNextRrMs': 'Следующий RR (мс)',
    'sensecap.axisCount': 'Частота',

    'disclaimers.title': 'Дисклеймеры',
    'disclaimers.new': 'Новый дисклеймер',
    'disclaimers.refresh': 'Обновить',
    'disclaimers.empty': 'Нет дисклеймеров',
    'disclaimers.dialogNew': 'Новый дисклеймер',
    'disclaimers.dialogEdit': 'Редактирование дисклеймера',
    'disclaimers.deleteConfirm': 'Удалить дисклеймер «{code}»?',
    'disclaimers.deleteFailed': 'Не удалось удалить дисклеймер',
    'disclaimers.saveFailed': 'Не удалось сохранить дисклеймер',
    'disclaimers.enterCode': 'Введите code',
    'disclaimers.duplicateCode': 'Code «{code}» уже существует',
    'disclaimers.enterBody': 'Введите текст',
    'disclaimers.enterAcknowledgementLabel': 'Введите подпись подтверждения',
    'disclaimers.invalidData': 'Некорректный JSON data',
    'disclaimers.colCode': 'Code',
    'disclaimers.colStatus': 'Статус',
    'disclaimers.colPlacement': 'Размещение',
    'disclaimers.colSeverity': 'Важность',
    'disclaimers.colBody': 'Текст',
    'disclaimers.colTargets': 'Привязки',
    'disclaimers.colActions': 'Действия',
    'disclaimers.fieldCode': 'Code',
    'disclaimers.fieldStatus': 'Статус',
    'disclaimers.fieldPlacement': 'Размещение',
    'disclaimers.fieldSeverity': 'Важность',
    'disclaimers.fieldRequireAcknowledgement': 'Требовать подтверждение',
    'disclaimers.fieldAcknowledgementLabel': 'Подпись подтверждения',
    'disclaimers.fieldTitle': 'Заголовок',
    'disclaimers.fieldBody': 'Текст',
    'disclaimers.fieldData': 'Data (JSON)',
    'disclaimers.fieldConfigurations': 'Конфигурации тестов',
    'disclaimers.fieldMetrics': 'Метрики',
    'disclaimers.status.active': 'Активен',
    'disclaimers.status.inactive': 'Неактивен',
    'disclaimers.placement.dialog': 'Диалог',
    'disclaimers.placement.inline': 'В тексте',
    'disclaimers.placement.card': 'Карточка',
    'disclaimers.severity.info': 'Информация',
    'disclaimers.severity.warning': 'Предупреждение',

    'legalDocuments.title': 'Юридические документы',
    'legalDocuments.new': 'Новый документ',
    'legalDocuments.newVersion': 'Новая версия',
    'legalDocuments.seed': 'Создать черновики каталога',
    'legalDocuments.seedConfirm': 'Создать недостающие черновики стандартного каталога?',
    'legalDocuments.seedFailed': 'Не удалось создать черновики',
    'legalDocuments.refresh': 'Обновить',
    'legalDocuments.empty': 'Нет документов',
    'legalDocuments.dialogNew': 'Новый юридический документ',
    'legalDocuments.dialogEdit': 'Редактирование документа',
    'legalDocuments.dialogVersion': 'Новая версия документа',
    'legalDocuments.publish': 'Опубликовать',
    'legalDocuments.publishConfirm': 'Опубликовать {code} версии {version}? Текущая активная версия станет superseded.',
    'legalDocuments.publishFailed': 'Не удалось опубликовать документ',
    'legalDocuments.supersede': 'Снять с публикации',
    'legalDocuments.supersedeConfirm': 'Пометить {code} версии {version} как superseded?',
    'legalDocuments.supersedeFailed': 'Не удалось снять документ',
    'legalDocuments.deleteConfirm': 'Удалить черновик {code} версии {version}?',
    'legalDocuments.deleteFailed': 'Не удалось удалить документ',
    'legalDocuments.saveFailed': 'Не удалось сохранить документ',
    'legalDocuments.enterCode': 'Введите code',
    'legalDocuments.enterVersion': 'Введите версию',
    'legalDocuments.invalidData': 'Некорректный JSON data',
    'legalDocuments.colCode': 'Code',
    'legalDocuments.colVersion': 'Версия',
    'legalDocuments.colStatus': 'Статус',
    'legalDocuments.colMode': 'Принятие',
    'legalDocuments.colTitle': 'Заголовок',
    'legalDocuments.colEffective': 'Действует с',
    'legalDocuments.colActions': 'Действия',
    'legalDocuments.fieldCode': 'Code',
    'legalDocuments.fieldVersion': 'Версия',
    'legalDocuments.fieldType': 'Тип',
    'legalDocuments.fieldMode': 'Вид принятия',
    'legalDocuments.fieldReacceptance': 'Требовать повторное согласие',
    'legalDocuments.fieldEffective': 'Дата вступления',
    'legalDocuments.fieldTitle': 'Заголовок',
    'legalDocuments.fieldContentUrl': 'URL контента',
    'legalDocuments.fieldHtml': 'Загрузить HTML',
    'legalDocuments.fieldData': 'Data (JSON)',
    'legalDocuments.localeEn': 'English',
    'legalDocuments.localeRu': 'Русский',
    'legalDocuments.status.draft': 'Черновик',
    'legalDocuments.status.active': 'Активен',
    'legalDocuments.status.superseded': 'Заменён',
    'legalDocuments.mode.required': 'Обязательное',
    'legalDocuments.mode.acknowledge': 'Ознакомление',
    'legalDocuments.mode.optional': 'Необязательное',
    'legalDocuments.mode.view_only': 'Только просмотр',
    'legalDocuments.type.terms': 'Terms',
    'legalDocuments.type.privacy': 'Privacy',
    'legalDocuments.type.esign': 'E-sign',
    'legalDocuments.type.health_data': 'Health data',
    'legalDocuments.type.team_sharing': 'Team sharing',
    'legalDocuments.type.guardian': 'Guardian',
    'legalDocuments.type.wellness': 'Wellness',
};
